import React from 'react';

function HeaderSelectAll(props) {
    const { selectAll, setSelectAll,checkbox } = props;

    const onChangeSelectAll = (e) => {
        setSelectAll((_) => ({
            ..._,
            isChecked: !_.isChecked
        }));
    };

    return (
        < >

      <div className="ag-header-select-all">
  {checkbox ? (
    <>
      <div className="ag-header-component"></div>
      <div className="selectAll-checkbox-size">
        <input
          id="checkboxMembers"
          type="checkbox"
          className="ag-checkbox-input"
          onChange={onChangeSelectAll}
          checked={selectAll?.isChecked || false}
        />
        <label htmlFor="checkboxMembers" className='ag-header-cell-text margLeft8'>
          {selectAll?.label}
        </label>
      </div>
    </>
  ) : (
    <label htmlFor="checkboxMembers" className={checkbox?'ag-header-cell-text margLeft8':'ag-header-cell-text'}>
      {selectAll?.label}
    </label>
  )}
</div>

            </>
    );
}

export default HeaderSelectAll;
